import React, { useState } from 'react';
import {
  Box, Tabs, Tab, Typography, Paper, Chip
} from '@mui/material';
import DiamondPricingTable from './DiamondPricingTable'; // your current component
import SolitairePricingTable from './SolitairePricingTable';

function TabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: { xs: 1.25, md: 1.75 } }}>{children}</Box>}
    </div>
  );
}

export default function PricingPage() {
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const tabSx = {
    textTransform: 'none',
    fontWeight: 600,
    minHeight: 44,
    color: '#475569',
    '&.Mui-selected': {
      color: '#1a1a1a',
      backgroundColor: '#fff8e8',
      borderRadius: '8px 8px 0 0',
    },
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '14px',
        border: '1px solid #e5e7eb',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          p: { xs: 1.5, md: 2 },
          borderBottom: '1px solid #e5e7eb',
          background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
          Pricing Management
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Update vendor pricing with fast, compact entry tables.
        </Typography>
        <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          <Chip size="small" label="Diamond Pricing" sx={{ backgroundColor: '#fff7e0' }} />
          <Chip size="small" label="Solitaire Pricing" sx={{ backgroundColor: '#fff7e0' }} />
        </Box>
      </Box>

      <Box sx={{ px: { xs: 1, md: 2 }, pt: 1, borderBottom: '1px solid #eceff3' }}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          aria-label="pricing tabs"
          variant="scrollable"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { backgroundColor: '#d4af37', height: 3 } }}
        >
          <Tab sx={tabSx} label="Diamond Pricing" />
          <Tab sx={tabSx} label="Solitaire Pricing" />
          {/* <Tab label="Metal Pricing" /> */}
        </Tabs>
      </Box>

      <TabPanel value={tabIndex} index={0}>
        <DiamondPricingTable />
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        {/* Placeholder - Replace with actual SolitairePricingTable component */}
        <SolitairePricingTable />
      </TabPanel>

      <TabPanel value={tabIndex} index={2}>
    
        <Typography variant="body1">Metal pricing table goes here.</Typography>
      </TabPanel>
    </Paper>
  );
}
